import type { PlatformKind } from './ports/types'

export interface ResolveShowcaseHostOptions {
  kind: PlatformKind
  /** Payload Dev will send to auth. Ignored for telegram / vk / none. */
  devPayload: string | null
  tgAppId: string
  vkAppId: string
}

/**
 * Channel identifier for `/showcases/v1/{showcaseHost}/…`.
 * Telegram → bot username, VK → app id. One path segment; `/` is rejected.
 * `none` and an empty id for the selected platform yield null (no hostname fallback).
 */
export function resolveShowcaseHost(
  options: ResolveShowcaseHostOptions,
): string | null {
  const tgAppId = usableChannelId(options.tgAppId)
  const vkAppId = usableChannelId(options.vkAppId)

  switch (options.kind) {
    case 'telegram':
      return tgAppId
    case 'vk':
      return vkAppId
    case 'dev':
      return payloadUsesVk(options.devPayload) ? vkAppId : tgAppId
    case 'none':
      return null
    default: {
      const _exhaustive: never = options.kind
      return _exhaustive
    }
  }
}

/** True when the launch query has at least one `vk_*` field. */
export function payloadUsesVk(payload: string | null | undefined): boolean {
  if (!payload?.trim()) {
    return false
  }
  const raw = payload.startsWith('?') ? payload.slice(1) : payload
  const params = new URLSearchParams(raw)
  for (const key of params.keys()) {
    if (key.startsWith('vk_')) {
      return true
    }
  }
  return false
}

function usableChannelId(value: string): string | null {
  const trimmed = value.trim()
  if (!trimmed || trimmed.includes('/')) {
    return null
  }
  return trimmed
}
